<template>
	<div class="contentList">
		<sideBar></sideBar>
		<div class=" main">
			<div>
				<div class="pull-left select-pull">
					<div class="type-select">
						<div class="type-text" @click="selectClick=!selectClick" :data-id="dataTable.selectCurrent.id">
							{{dataTable.selectCurrent.name}}
							<div class="type-icon"></div>
						</div>
						<ul class="type-list" v-show="selectClick">
							<li v-for="item in selectList" @click="seleckDown(item)" :data-id="item.id">{{item.name}}</li>
						</ul>
					</div>
					<div class="search-input">
						<div class="search-icon"></div>
						<input type="text" :value="q" v-on:input="search($event)" class="noneInput" placeholder="输入搜索内容" style="">
					</div>
				</div>
				<div class="pull-right" v-if="addIcon">
					<a class="add-btn" href="/contentEdit">
						<div class="add-icon"></div>
						发布内容
					</a>
				</div>
			</div>
			<div class = "list-div">
				<ul class="file-list">
					<li class="file-li" v-for="(item,index) in listFunData" v-if="listFunData.length>0">
						<div class="file-content">
							<div class="file-title">{{item.contentname}}</div>
							<div class="file-row">
								<div class="file-actor">{{item.publisher}}</div>
								<div class="file-date">{{moment(item.createat).format('YYYY-MM-DD')}}</div>
							</div>
							<div class="btn-group file-btn">
								<a class="deal-btn edit-btn" :href="'/contentEdit?id='+item.id" v-if="item.permission!=2"></a>
								<a class="deal-btn find-btn" :href="'/contentQuery?id='+item.id"></a>
								<a class="deal-btn del-btn" href="javascript:void(0)" @click="deleteItem(item.id,index)" v-if="item.permission==0"></a>
							</div>
						</div>
					</li>
				</ul>
				<div class = "list-processing" v-if = "listStatus">处理中...</div>
			</div>
			<div class="nodata2" v-if="listFunData.length<=0">暂无数据...</div>
			<pagination :total="count" :current-page='dataTable.currentPage' :totalPage='totalPage' @pagechange="pagechange"></pagination>
			
		</div>
	</div>
</template>
 
<script>
	import pagination from "@/components/pagination"
	import sideBar from "@/components/comHtml/sideBar"
	export default {
		name: 'contentList',
		data() {
			return {
				selectList: [{
						name: "全部",
						id: "1"
					},
					{
						name: "标题",
						id: "2"
					},
					{
						name: "标签",
						id: "3"
					},
					{
						name: "发布人",
						id: "4"
					}
				],
				listStatus:false,
				selectClick: false,
				addIcon: false,
				listFunData: [],
				click: false,
				totalPage: 1,
				count: 1,
				q: "",
				dataTable: {
					//总页数
					currentPage: 1,
					start: 0,
					pageSize: 30, //每页数据量
					selectCurrent: {
						name: "全部",
						id: "1"
					}
				}
			}
		},
		components: {
			sideBar,
			pagination
		},
		created: function() {
			this.getLocalUser.permissions.forEach((k) => {
				if(k.permissionname == "发布内容") {
					this.addIcon = true;
					return;
				}
			})
			this.init();
		},
		methods: {
			init: function() {
				if(this.$route.query.q){
					this.q = this.$route.query.q;
					this.dataTable.selectCurrent = {
						name: "标签",
						id: "3"
					}
				}else{
					if(localStorage.getItem("dataTable" + this.$route.name) != null) {
						this.dataTable = JSON.parse(localStorage.getItem("dataTable" + this.$route.name))
					}
				}
				
				this.refreshTable();
			},
			pagechange: function(currentPage) {
				this.click = true;
				this.dataTable.currentPage = currentPage;
				this.dataTable.start = this.dataTable.pageSize * (currentPage - 1);
				this.refreshTable();
			},
			listFun: function(data) {
				if(data && data.errcode == '0') {
					this.listStatus = false;
					this.totalPage = Math.ceil(data.count / this.dataTable.pageSize);
					this.count = data.count;
					if(this.click == true) {
						localStorage.setItem("dataTable" + this.$route.name, JSON.stringify(this.dataTable));
					}
					this.listFunData = data.list;
				}
			},
			search: function($event) {
				this.q = $.trim($event.target.value);
				this.click = false;
				this.start = 0;
				this.dataTable.currentPage = 1;
				this.refreshTable();
			},
			seleckDown: function(data) {
				this.dataTable.selectCurrent = data;
				this.selectClick = false
			},
			deleteItem: function(id, index) {
				let _this = this
				this.layer.confirm("确定删除吗?", (index) => {
					this.layer.close(index);
					this.common.get('content/deleteContent', function(ret) {
						if(ret.errcode) {
							return _this.layer.alert(ret.errmsg);
						}
						_this.layer.alert(ret.errmsg);
						_this.refreshTable();
					}, {
						id: id
					}, true)
				})

			},
			refreshTable: function(data) {
				data = {
					start: this.dataTable.start,
					limit: this.dataTable.pageSize,
					q: this.q,
					type: this.dataTable.selectCurrent.id,
					publisherId: this.getLocalUser.id
				}
				this.common.get('content/contentList', this.listFun, data,true,()=>{
					this.listStatus = true
				});
			},
			autoHide(evt) {
				if(!$(".type-select")[0].contains(evt.target)) {
					this.selectClick = false
				}
			}
		},
		mounted() {
			document.addEventListener('click', this.autoHide, false)
		},
		destroyed() {
			document.removeEventListener('click', this.autoHide, false)
		}

	}
</script>

<style scoped="">
	@import url("../../static/css/table.css");
</style>


// WEBPACK FOOTER //
// src/assets/contentList.vue